import React from "react";
import { useSearchParams } from "react-router-dom";
import Grid, { Columns } from "../../component/Grid";
import useLocale from "../../util/i18n";
import { QueueData, cancelQueue, getQueue } from "../../api/email";
import { useCrumbs } from "../../component/breadcrumbs";
import { Helmet } from "react-helmet-async";
import Toast from "../../component/toast";

export default function EmailQueue() {
    const { 0: query, 1: setQuery } = useSearchParams();
    const { 0: __, 1: lang } = useLocale();
    let columns = React.useMemo<Columns>(() => ({
        template_id: {
            label: __('Template'),
            format: (value, item) => item.subject
        },
        rcpt: {
            label: __('Recipient'),
            format: (value: Array<string>) => (<>{value.map((email, i) => (<div key={email + i}>{email}</div>))}</>)
        },
        status: {
            label: __('Status'),
            className: 'w-1 text-center text-nowrap',
            filterable: 'status',
            type: 'select',
            options: [
                { value: '1', label: __('Sent') }, { value: '0', label: __('Queue up') }
            ],
            format: (value: number) => value > 0 ? __('Sent') : (value < 0 ? __('Canceled') : __('Queue up'))
        },
        scheduled_at: {
            label: __('Scheduled at'),
            className: 'w-1 text-center text-nowrap',
            format: value => Intl.DateTimeFormat(lang, { dateStyle: 'medium', timeStyle: 'short' }).format(value)
        }
    }), [__, lang]);
    let actions = React.useMemo(() => ([
        {
            label: __('Cancel'),
            onClick: (item: QueueData) => {
                if (window.confirm(__('Are you sure to cancel this schedule?'))) {
                    cancelQueue(item.id).then(response => Toast.show(response));
                }
            }
        }
    ]), [__]);
    const doLoad = React.useCallback((params: Record<string, any>) => {
        return getQueue(params);
    }, []);
    const { 0: setCrumbs } = useCrumbs();
    React.useEffect(() => {
        setCrumbs(['Email Queue']);
    }, [setCrumbs]);
    return (
        <>
            <Helmet>
                <title>{__('Email Queue')}</title>
            </Helmet>
            <Grid columns={columns} actions={actions} query={query} setQuery={setQuery} doLoad={doLoad} />
        </>
    );
}
